<template>
  <div>
    <v-dialog v-model="show" persistent scrollable max-width="800px">
      <v-card flat>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1" flat dark height="50px">
            <span>{{ $t('home.wallpaperUploadTitle') }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="onClose(false)" />
          </v-toolbar>
        </v-banner>
        <v-card-text style="">
          <v-form ref="form" lazy-validation>
          <v-row>
            <v-col cols="12" sm="12" class="" v-cloak @drop.prevent="addDropFile" @dragover.prevent>
              <v-file-input
                class="fileupload mb-3"
                ref="inputUpload"
                name="attachment"
                :placeholder="$t('documents.dropFileHere')"
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                lable="Upload file"
                :accept="file_accept"
                outlined
                dense
                @change="addFiles"
                hide-details
                :key="componentKey"
                @click:prepend-inner="iconClickable"
              >
              </v-file-input>
              <p
                v-if="isFileRequired"
                style="color: var(--v-error-base); ma"
                >{{ this.$t("documents.uploadedValidationMessage") }}</p
              >
              <span class="text-subtitle-1">
                <v-icon :color="file ? (checkStatus(file).status !== true ? 'error' : '') : ''" small> mdi-information </v-icon> 
                <small :class="file ? (checkStatus(file).status !== true ? 'error--text' : '') : ''"> 
                  {{ $t('home.wallpaperUploadFiletypes', { maxsize: formatBytes(maxsize),}) }} </small>
              </span><br>
              <span class="text-subtitle-1">
                <v-icon :color="file ? (checkStatus(file).status !== true ? 'error' : '') : ''" small> mdi-information </v-icon> 
                <small :class="file ? (checkStatus(file).status !== true ? 'error--text' : '') : ''"> {{ $t('home.wallpaperDimension') }} </small>
              </span>
            </v-col>
            <v-col cols="12" sm="12" class="pt-2 pb-0">
              <v-divider v-if="file" :class="file ? 'my-2' : ''"></v-divider>
              <v-list-item
                v-if="file"
                link
                :class="[
                  checkStatus(file).status !== true ? 'v-list-item--active' : '',
                ]"
                :color="checkStatus(file).status !== true ? '#990000' : ''"
              >
                <v-list-item-avatar>
                  <v-icon
                    v-text="icons[file.extension] || 'mdi-file'"
                    class="mdi-36px"
                    color="grey lighten-1"
                  ></v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="file.name"></v-list-item-title>
                  <v-list-item-subtitle
                    >{{ formatBytes(file.size) }} -
                    {{ file.type }}</v-list-item-subtitle
                  >
                </v-list-item-content>

                <v-list-item-action v-if="checkStatus(file).status !== true">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="error lighten-1"
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-alert
                      </v-icon>
                    </template>
                    <span>{{ checkStatus(file).message }}</span>
                  </v-tooltip>
                </v-list-item-action>

                <v-list-item-action>
                  <v-btn icon @click="remove">
                    <v-icon
                      :color="
                        checkStatus(file).status == true
                          ? 'grey lighten-1'
                          : 'error lighten-1'
                      "
                      >mdi-close</v-icon
                    >
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-col>
          </v-row>
        </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <span
            v-if="errorCount > 0"
            class="error--text text-subtitle-1"
            ><small>{{
              $t("documents.invalidFileMsg", { count: errorCount })
            }}</small></span
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">    
              <a-btn
                v-bind="attrs" v-on="on"
                color="primaryDark"
                class="mr-2"
                @click.stop="saveDocument"
                :disabled="errorCount > 0 || !file"
              >
                {{ $t("btnSave") }}
              </a-btn>
            </template>
            <span>{{ $t("btnSave") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn v-bind="attrs" v-on="on" color="secondary" @click="onClose(false)">{{ $t("btnClose") }}</a-btn>
            </template>
            <span>{{ $t("btnClose") }}</span>
          </v-tooltip>
         
        </v-card-actions>
      </v-card>
    </v-dialog>
    <prevent-confirmation
      :prevent="isDataUnSaved"
      @save="saveDocument"
      @discard="preventClose(true)"
      @cancel="preventClose(false)"
    >
    </prevent-confirmation>
  </div>
</template>

<script>
import { fileIcons, LANDING_PAGE_WALLPAPER_SIZE } from "../../utils/constant";
import { formatBytes, createUUID } from "../../utils/util";
import { mapActions } from "vuex";
import PreventConfirmation from "../PreventConfirmation.vue";

export default {
  name: "LandingPictureDialog",
  components: {
    PreventConfirmation
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    documentForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDataUnSaved: false,
      title: null,
      componentKey: 0,
      maxsize: LANDING_PAGE_WALLPAPER_SIZE,
      icons: fileIcons,
      file: null,
      file_accept: ["image/png", "image/jpeg", "image/jpg"],
      isFileRequired: false,
      caption: '',
      isDescriptionWithImage: null,
    };
  },
  computed: {
    LoaderText() {
      return this.$t("LoaderText");
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    errorCount() {
      let count = 0;
      if (this.file && this.checkStatus(this.file).status == false) {
        count++;
      }
      return count;
    },
  },
  watch: {
    file(value) {
      if (value) {
        this.isFileRequired = false;
      }
    },
  },
  methods: {
    ...mapActions({
      createLandingPageWallpaper: "tenant/createLandingPageWallpaper",
    }),
    onClose,
    addDropFile,
    addFiles,
    remove,
    checkStatus,
    formatBytes,
    saveDocument,
    createUUID,
    preventClose,
    iconClickable() {
      this.$refs.inputUpload.$el.querySelector("input").click();
    },
  },
};

async function saveDocument() {
  try {
    if (this.file && this.$refs.form.validate()) {
      this.isFileRequired = false;
      let formData = new FormData();
      formData.append("filename", this.file.name);
      formData.append("content_type", this.file.type);
      formData.append("file", this.file);
      await this.createLandingPageWallpaper(formData);
      this.$emit("alert", this.$t("home.documentUploadSuccess"), "success" ,'wallpaper');
      this.onClose(true);
    } else {
      this.isFileRequired = true;
    }
  } catch (error) {
    console.log(error, "api error")
  }
}

function remove() {
  this.file = null;
  this.$refs.inputUpload.reset();
}

function checkStatus(file) {
  const maxSize = this.maxsize ?? 0;
  let filesWithStatus = {};
  if (!this.file_accept.includes(file.type)) {
    filesWithStatus = {
      filename: file.name,
      status: false,
      message: this.$t("fileErrorMsg", { filename: file.fileName }),
    };
  } else if (file.size > maxSize) {
    filesWithStatus = {
      filename: file.name,
      status: false,
      message: this.$t("fileSizeErrorMsg", {
        maxsize: formatBytes(maxSize),
      }),
    };
  } else {
    filesWithStatus = {
      filename: file.name,
      status: true,
      message: "Success",
    };
  }
  return filesWithStatus;
}

function addFiles(files) {
  this.file = files;
  this.componentKey++;
}

async function addDropFile(e) {
  Array.from(e.dataTransfer.files).forEach((file) => {
    this.file = file;
  });
}

function onClose(fromSave) {
  const isPendingChanges = this.file && this.$refs.form.validate() && !this.errorCount
  if(isPendingChanges && !fromSave) {
    this.isDataUnSaved = true
  } else {
    this.$refs.form.resetValidation();
    this.$refs.form.reset();
    this.show = false
    this.$emit("input", false);
  }
}

function preventClose(status) {
  this.isDataUnSaved = false;
  if (status) {
    this.show = false;
  } 
}
</script>

<style>
</style>